import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row items-center justify-between q-px-md q-pt-md q-pb-20" }
const _hoisted_2 = {
  key: 0,
  class: "fs-17px fw-600 text-cool-gray-100"
}
const _hoisted_3 = {
  key: 1,
  class: "fs-17px fw-600 text-cool-gray-100"
}
const _hoisted_4 = {
  key: 0,
  class: "BaseItemDialog__content flex column no-wrap"
}
const _hoisted_5 = {
  key: 1,
  class: "BaseItemDialog__content full-width flex flex-center flex-1"
}

import useBaseItemDialogHook from './BaseItemDialogHook'
import BaseItemDialogPreview from './components/BaseItemDialogPreview.vue'
import BaseItemDialogTabs from './components/BaseItemDialogTabs.vue'
import { IBaseItemDialogProps } from './interfaces'


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseItemDialog' },
  __name: 'BaseItemDialog',
  props: /*@__PURE__*/_mergeModels({
    id: {},
    categories: { default: () => [] },
    categoryName: { default: undefined },
    menuItem: { default: undefined }
  }, {
    "modelValue": { type: Boolean, ...{ default: false } },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {


const model = _useModel<boolean>(__props, "modelValue")
const props = __props

const { state, ...hook } = useBaseItemDialogHook({ props, model })

return (_ctx: any,_cache: any) => {
  const _component_k_circle_icon = _resolveComponent("k-circle-icon")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_k_dialog = _resolveComponent("k-dialog")!

  return (_openBlock(), _createBlock(_component_k_dialog, {
    modelValue: model.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model).value = $event)),
    position: "right",
    class: "BaseItemDialog",
    "content-class": "BaseItemDialog__wrapper flex no-wrap rounded-24 overflow-auto hide-scrollbar"
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!_unref(state).loading.fetch && __props.categoryName)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.categoryName), 1 /* TEXT */))
          : (!_unref(state).loading.fetch)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.categories.find((category) => category.id === _unref(state).item?.category_id)?.name ?? ''), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
        (!_unref(state).loading.fetch)
          ? (_openBlock(), _createBlock(_component_k_circle_icon, {
              key: 2,
              "is-hover": "",
              name: "edit",
              size: "24px",
              color: "cool-gray-70",
              "root-class": "q-pa-sm cursor-pointer bg-white q-ml-auto",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (
            _ctx.$router.push({ name: 'ItemEntity', params: { id: _unref(state).item.id, categoryId: _unref(state).item.category_id } })
          ))
            }))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    content: _withCtx(() => [
      (!_unref(state).loading.fetch && __props.id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createCommentVNode(" <div v-if=\"Number(menuItem?.price) !== 0\" class=\"fs-15px fw-500 text-error-100\">Price Overridden</div> "),
            _createCommentVNode(" <div v-if=\"menuItem?.menu_item_name !== ''\" class=\"fs-15px fw-500 text-error-100\">Name Overridden</div> "),
            _createVNode(BaseItemDialogPreview, {
              item: _unref(state).item,
              currency: hook.currency_code
            }, null, 8 /* PROPS */, ["item", "currency"]),
            _createVNode(BaseItemDialogTabs, {
              item: _unref(state).item,
              currency: hook.currency_code
            }, null, 8 /* PROPS */, ["item", "currency"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_q_spinner, {
              color: "cool-gray-40",
              size: "3em"
            })
          ]))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue"]))
}
}

})